import InnerComponent from '@Components/Production/BOMList';
import orgContainer from '@Components/AppContainer';

const Index = () => ((orgContainer(InnerComponent)));
export default Index;
